var _path, _g, _path2, _path3, _path4, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 14H32v6h27.5c-.9-2.1-2.1-4.2-3.5-6",
    fill: "#428bc1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f9f9f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 14h24c-1.7-2.3-3.7-4.3-6-6H32v6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5 20H32v6h29.4c-.4-2.1-1.1-4.1-1.9-6"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 44h55c.8-1.9 1.5-3.9 1.9-6H2.6c.4 2.1 1.1 4.1 1.9 6",
    fill: "#428bc1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 50h48c1.4-1.8 2.6-3.9 3.5-6h-55c.9 2.1 2.1 4.2 3.5 6",
    fill: "#f9f9f9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 50c1.7 2.3 3.7 4.3 6 6h36c2.3-1.7 4.3-3.7 6-6H8z",
    fill: "#428bc1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#f9f9f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 56c5 3.8 11.2 6 18 6s13-2.2 18-6H14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 32V20h12v-6H20V4.5c-2.1.9-4.2 2.1-6 3.5v6H8c-1.4 1.8-2.6 3.9-3.5 6H14v12H2c0 2.1.2 4.1.6 6h58.8c.4-1.9.6-3.9.6-6H20"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#428bc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.4 26H32v-6H20v12h42c0-2.1-.2-4.1-.6-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 2c-4.3 0-8.3.9-12 2.5V14h12V8h18c-5-3.8-11.2-6-18-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14V8c-2.3 1.7-4.3 3.7-6 6h6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 20C2.9 23.7 2 27.7 2 32h12V20H4.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEl);
export default __webpack_public_path__ + "static/media/el.600f3fee51e1ac6806d7573e18089dfc.svg";
export { ForwardRef as ReactComponent };